<div
  class="flex items-center justify-between border-t border-slate-100 bg-white px-3 py-2.5 sm:px-5 sm:py-3"
>
  <!-- Version mobile -->
  <div class="flex sm:hidden flex-1 justify-between items-center">
    <button
      type="button"
      class="relative inline-flex items-center rounded-md px-3 py-2 text-sm font-semibold text-slate-900 ring-1 ring-inset ring-slate-200 hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed"
      [disabled]="paginaActual() === 1"
      (click)="cambiarPagina(paginaActual() - 1)"
    >
      Anterior
    </button>
    <span class="text-xs text-gray-700"> Pág. {{ paginaActual() }} de {{ totalPaginas() }} </span>
    <button
      type="button"
      class="relative inline-flex items-center rounded-md px-3 py-2 text-sm font-semibold text-slate-900 ring-1 ring-inset ring-slate-200 hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed"
      [disabled]="paginaActual() === totalPaginas()"
      (click)="cambiarPagina(paginaActual() + 1)"
    >
      Siguiente
    </button>
  </div>

  <!-- Version desktop -->
  <div class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between w-full">
    <div>
      <p class="text-sm text-slate-600">
        Mostrando
        <span class="font-medium">{{
          items().length > 0 ? (paginaActual() - 1) * itemsPorPagina() + 1 : 0
        }}</span>
        a
        <span class="font-medium">{{
          (paginaActual() - 1) * itemsPorPagina() + items().length
        }}</span>
        de
        <span class="font-medium">{{ totalItems() > 0 ? totalItems() : items().length }}</span>
        resultados
      </p>
    </div>
    <div>
      <nav aria-label="Pagination" class="isolate inline-flex -space-x-px rounded-lg shadow-sm">
        <button
          type="button"
          class="relative inline-flex items-center rounded-l-lg px-1.5 sm:px-2 py-1.5 sm:py-2 text-slate-400 ring-1 ring-slate-200 hover:bg-slate-50 focus:z-20 focus:outline-offset-0 disabled:opacity-50"
          [disabled]="paginaActual() === 1"
          (click)="cambiarPagina(paginaActual() - 1)"
        >
          <span class="sr-only">Anterior</span>
          <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="size-5">
            <path
              d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
            />
          </svg>
        </button>
        @for (item of paginasVisibles(); track item) {
          @if (item === '...') {
            <span
              class="relative inline-flex items-center px-3 py-2 text-sm text-gray-400 select-none"
              >…</span
            >
          } @else {
            <button
              type="button"
              class="relative inline-flex items-center px-4 py-2 text-sm font-semibold focus:z-20 focus:outline-offset-0"
              [class.bg-accent-600]="paginaActual() === item"
              [class.text-white]="paginaActual() === item"
              [class.text-slate-900]="paginaActual() !== item"
              [class.ring-1]="true"
              [class.ring-gray-300]="true"
              [class.focus:bg-blue-700]="true"
              [class.hover:bg-gray-200]="paginaActual() !== item"
              (click)="cambiarPagina(+item)"
            >
              {{ item }}
            </button>
          }
        }
        <button
          type="button"
          class="relative inline-flex items-center rounded-r-lg px-2 py-2 text-slate-400 ring-1 ring-slate-200 hover:bg-slate-50 focus:z-20 focus:outline-offset-0"
          [disabled]="paginaActual() === totalPaginas()"
          (click)="cambiarPagina(paginaActual() + 1)"
        >
          <span class="sr-only">Siguiente</span>
          <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="size-5">
            <path
              d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
            />
          </svg>
        </button>
      </nav>
    </div>
  </div>
</div>
